import React, {useEffect, useState} from "react";
import {SigninForm} from "../molecules/SigninForm";
import Button from '@mui/material/Button';
import axios from "axios";
import {getAxiosBaseUrl, getGisBaseUrl} from "../../config";
import {Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis} from 'recharts';
import icon from '../../assets/mapPin.png'
import usericon from '../../assets/userIcon.png'
import L from 'leaflet';
import {MapContainer, Marker, Popup, Rectangle, TileLayer, useMap} from "react-leaflet";
import DiscreteSliderValues from "./DiscreteSliderValues";
import * as jobUtils from "./jobUtils";

const customIconUser = new L.Icon({
	iconUrl: usericon,
	iconSize: [25, 41], // Size of the icon
	iconAnchor: [12, 41], // Point of the icon which will correspond to marker's location
	popupAnchor: [1, -34], // Point from which the popup should open relative to the iconAnchor
});
const customIcon = new L.Icon({
	iconUrl: icon, // URL to your custom icon
	iconSize: [25, 41], // Size of the icon
	iconAnchor: [12, 41], // Point of the icon which will correspond to marker's location
	popupAnchor: [1, -34], // Point from which the popup should open relative to the iconAnchor
	// shadowUrl: 'path_to_your_icon_shadow.png', // Optional shadow image
	// shadowSize: [41, 41]
});

// import stemmer from 'stemmer';
// const natural = require('natural');
// const porterStemmer = natural.PorterStemmer;

export default function JobPool() {
	const gisUsername = 'nominatim';
	const gisPassword = 'utegis2!';
	const [joburls, setjoburls] = useState([]);
	const [alldatalength, setAllDataLength] = useState(0);
	const [fltrdjoburls, setfltrdjoburls] = useState([]);
	const [gisDataArr, setgisDataArr] = useState([]);
	// const fltrdjoburls1 = []
	var signedin = sessionStorage.getItem("signedin");
	const [companyChartData, setcompanyChartData] = useState([]);
	const [companyChartDataProcessed, setcompanyChartDataProcessed] = useState({});
	const [jobSummaryCount, setjobSummaryCount] = useState(0);
	const [ipLatLongLocations, setipLatLongLocations] = useState([]);
	const [miles, setmiles] = useState(20);
	const [jobLocations, setjobLocations] = useState([]);
	const [bbox, setbbox] = useState([[37.3331279618023, -122.07153696569458], // Southwest corner
		[37.35838814165478, -122.03975737931526] // Northeast corner
	]);
	const [query, setQuery] = useState('95050');
	
	const useFlexSearch = (joburls) => {
		// const [index, setIndex] = useState(null);
		// useEffect(() => {
		// 	const newIndex = new FlexSearch.Index({
		// 		// tokenize: 'forward',
		// 		tokenize: "full", matcher: "simple", cache: true
		// 	});
		//
		// 	joburls.forEach((job, id) => {
		// 		newIndex.add(id, job.jobSummary.toLowerCase() + ' ' + job.keywords.join(' ').toLowerCase());
		// 	});
		//
		// 	setIndex(newIndex);
		// }, [joburls]);
		//
		// return index;
	};
	const index = useFlexSearch(joburls);
	
	function handleSubmitQuery() {
		getGisData();
	}
	
	function getAndSetCurrentDistanceValue(miles) {
		// console.log('miles', miles)
		const newBbox = jobUtils.getBoundingBox(parseFloat(gisDataArr[0].lat), parseFloat(gisDataArr[0].lon), miles)
		setbbox(newBbox);
		setmiles(miles);
	}
	
	function getGisData() {
		axios.defaults.baseURL = getGisBaseUrl();
		// console.log('query ', axios.defaults.baseURL + '/search.php?q=' + query)
		axios.get('/search.php?q=' + query, {
			auth: {
				username: gisUsername,
				password: gisPassword
			}
		}).then(response => {
			const gisDataArr = response.data
			setgisDataArr(gisDataArr);
			const newBbox = jobUtils.getBoundingBox(parseFloat(gisDataArr[0].lat), parseFloat(gisDataArr[0].lon), miles)
			setbbox(newBbox);
		}).catch(error => {
			if (error.response) {
				console.log("Error data:", error.response.data);
				console.log("Error status:", error.response.status);
				console.log("Error headers:", error.response.headers);
			} else if (error.request) {
				console.log("No response received:", error.request);
			} else {
				console.log('Error', error.message);
			}
			console.log("Config:", error.config);
		});
	}
	
	function getDictionaryForCompanyData(allData) {
		const count = {};
		const countProcessed = {};
		allData.forEach(rec => {
			const name = jobUtils.extractCompanyName(rec['jobUrl']);
			count[name] = (count[name] || 0) + 1;
			if ('date_posted' in rec) {
				countProcessed[name] = (countProcessed[name] || 0) + 1;
			}
		});
		
		const companyChartData = Object.keys(count).map(key => {
				if (key == 'Amazon') {
					return ({name: key, availableCount: 0, processedCount: 0})
				}
				return {
					name: key,
					processedCount: countProcessed[key] || 0,
					availableCount: count[key] - (countProcessed[key] || 0),
				};
			}
		)
		return companyChartData;
	}
	
	function handleAddressChange(e) {
		e.preventDefault();
		setQuery(e.target.value)
	}
	
	function getAndSetJobData() {
		axios.defaults.baseURL = getAxiosBaseUrl();
		axios.post('fetchJobUrlsEsWLatLongs', {
			'verifiedemail': sessionStorage.getItem("verifiedemail")
		}).then(response => {
			const allData = response.data
			setAllDataLength(allData.length)
			const filteredData = allData.filter(rec => 'date_posted' in rec)
			
			let companyChartData = getDictionaryForCompanyData(allData)
			setcompanyChartData(companyChartData)
			setjoburls(filteredData);
			setfltrdjoburls(filteredData);
			const allLatLongs = []
			filteredData.map(rec => {
					if ('latlongs' in rec) {
						rec['latlongs'].split(';').map(latLong => {
							const lat_ = latLong.split(',')[0]
							const long_ = latLong.split(',')[1]
							allLatLongs.push({
								'title': rec.title,
								'company': jobUtils.extractCompanyName(rec.jobUrl),
								'jobUrl': rec.jobUrl,
								'lat': lat_,
								'lon': long_
							})
						})
					}
				}
			)
			setjobLocations(allLatLongs);
		})
		// axios.post('getJobUrls', {
		// 	'verifiedemail': sessionStorage.getItem("verifiedemail")
		// }).then(response => {
		// 	const allData = response.data
		// 	const filteredData = allData.filter(rec => 'date_posted' in rec)
		// 	setjoburls(filteredData);
		// 	setfltrdjoburls(filteredData);
		// }).catch(err => console.log(err));
	}
	
	function RecenterMap({gisData}) {
		const map = useMap();
		
		React.useEffect(() => {
			if (gisData.length > 0) {
				const newCenter = [gisData[0].lat, gisData[0].lon];
				map.flyTo(newCenter, map.getZoom());
			}
		}, [gisData, map]); // Dependency array to trigger effect when gisData changes
		
		return null; // Component does not render anything
	}
	
	const FitBounds = ({bbox}) => {
		const map = useMap();
		
		useEffect(() => {
			if (!bbox || bbox.length !== 2) return; // Ensure bbox is correctly formatted
			
			// Convert string values to numbers if they are passed as strings
			const correctedBBox = bbox.map(point => [parseFloat(point[0]), parseFloat(point[1])]);
			
			// Fit map view to bounding box
			// map.fitBounds(correctedBBox);
			map.fitBounds(correctedBBox, {paddingTopLeft: [0, 0], paddingBottomRight: [0, 0]});
		}, [bbox, map]);
		
		// Draw the bounding box
		return <Rectangle bounds={bbox} color="lightskyblue"/>;
	};
	
	useEffect(() => {
		function getAccessToken() {
			getAndSetJobData();
			getGisData();
		}
		
		getAccessToken();
	}, []);
	
	function addJobUrl() {
		const jobUrl = document.getElementById('joburl').value
		axios.defaults.baseURL = getAxiosBaseUrl();
		axios.post('submitJobUrlEs', {
			'verifiedemail': sessionStorage.getItem("verifiedemail"), 'jobUrl': jobUrl
		}).then(response => {
			document.getElementById('joburllabel').innerText = response.data.data
			document.getElementById('joburl').value = ''
			// getAndSetJobData();
		}).catch(err => console.log(err));
	}
	
	function getPageSource(record) {
		if ('pg_source' in record) {
			return record['pg_source']
		}
		return '-'
	}
	
	function getKeywords(record) {
		if ('keywords' in record) {
			return record['keywords'].map(rec => <div style={{
				padding: "2px", wordWrap: "break-word", wordBreak: "break-word",
				wordSpacing: "0.01em", display: "flex"
			}}>{rec},</div>)
		}
		return '-'
	}
	
	function getJobSummary(record) {
		if ('jobSummary' in record) {
			if (record['jobUrl'].includes('apple')) {
				return record['jobSummary'] + ' ' + record['keyQualifications'] + ' ' + record['educationAndExperience']
			} else {
				return record['jobSummary']
			}
		}
		return '-'
	}
	function copyText(text) {
		navigator.clipboard.writeText(text);
		// console.log(text);
	}
	
	// function handleInputChange(e) {
	// 	const localToken = e.target.value
	// 	setaccessToken(localToken);
	// 	//Sync to the database as well
	// 	// upsertToDb('userdata', {'email': sessionStorage.getItem("verifiedemail")}, {'shopifyStoreName': localToken})
	// }
	
	
	function filterBySearch(e) {
		// if (!index) {
		// 	setfltrdjoburls(joburls);
		// 	return;
		// }
		// if (e.target.value.length < 1) {
		// 	setfltrdjoburls(joburls);
		// 	return
		// }
		// const words = e.target.value.toLowerCase().split(' ').filter(rec => rec.length > 0);
		// const stemmedWords = words //.map(word => stemmer(word));
		// const searchQuery = stemmedWords.join(" "); // Join the stemmed words for the search query
		// const resultIds = index.search(searchQuery, {limit: 1000}); // Adjust limit as needed
		// const docMatchedWQuery = resultIds.map(id => joburls[id]);
		// setfltrdjoburls(docMatchedWQuery);
		// // const stemmedWords = words.map(word => stemmer(word));
		// // const docMatchedWQuery = joburls.filter(rec => {
		// // 	const jdText = rec['jobSummary'].toLowerCase().split(' ').map(word => stemmer(word))
		// // 	let matchCount = 0;
		// //
		// // 	stemmedWords.forEach(token => {
		// // 		if (jdText.includes(token)) {
		// // 			matchCount++;
		// // 		}
		// // 	})
		// // 	return matchCount > 0
		// // })
		// // setfltrdjoburls(docMatchedWQuery);
	}
	
	if (!signedin) {
		return <div style={{marginTop: "300px"}}>
			<SigninForm/>
		</div>
	} else {
		return (<div style={{
			marginTop: "10px", marginLeft: "0px", minHeight: "0px",
		}}>
			<div style={{fontSize: "20px", display: "flex"}}>Jobs Pool</div>
			<div style={{marginBottom: "0px", display: "flex"}}>
				<div style={{fontSize: "5x"}}> Available Jobs: {jobUtils.getFormatted(fltrdjoburls.length)}</div>
				{/*<div style={{fontSize: "5x", marginLeft: "10px"}}> Job Summary Available for: {getFormatted(joburls.length)}</div>*/}
			</div>
			{/*<ProgressBar totalJobs={alldatalength} summaryAvailable={joburls.length}/>*/}
			<div style={{marginTop: "5px", marginBottom: "20px", display: "flex"}}>
				<BarChart width={600} height={300} data={companyChartData} margin={{right: 30, left: 20, top: 20}}>
					<CartesianGrid strokeDasharray="3 3"/>
					<XAxis dataKey="name" angle={-45} textAnchor="end" interval={0} height={60}/>
					<YAxis/>
					<Tooltip/>
					<Legend wrapperStyle={{position: 'relative', top: -5}}/>
					<Bar dataKey="processedCount" fill="#8884d8" stackId="a" name="Jobs Available"
					     style={{marginTop: "-10px"}}/>
					{/*<Bar dataKey="availableCount" fill="#82ca9d" stackId="a" name="Processing"/>*/}
				</BarChart>
				{/*<MapContainer*/}
				{/*	style={{*/}
				{/*		height: "500px",*/}
				{/*		width: "500px",*/}
				{/*	}}*/}
				{/*	center={[48.3544, -99.9940]} // Adjusted to near the center of North America*/}
				{/*	zoom={3}> // Decreased zoom level to show the whole continent*/}
				{/*	<TileLayer*/}
				{/*		className="custom-opacity-tiles"*/}
				{/*		attribution="Google Maps"*/}
				{/*		url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"*/}
				{/*	/>*/}
				{/*	{ipLatLongLocations.map((location, index) => (*/}
				{/*		<Marker key={index} position={location} icon={customIcon}/>*/}
				{/*	))}*/}
				{/*</MapContainer>*/}
			</div>
			<input id='campaignname' placeholder="Enter zipcode / city name / address here" onChange={handleAddressChange}
			       onKeyDown={(e) => {
				       if (e.key === 'Enter') {
					       handleSubmitQuery();
				       }
			       }}
			       style={{
				       lineHeight: 3,
				       textAlign: "center",
				       marginLeft: 10, marginBottom: "20px",
				       width: 300,
				       border: "1px solid gray",
				       borderRadius: "10px"
			       }}/>
			<Button variant='outlined' onClick={() => handleSubmitQuery()} style={{marginLeft: "50px"}}>Submit</Button>
			<MapContainer
				style={{
					height: "500px",
					width: "1000px",
				}}
				center={[37.34409429790077, -121.95347724990458]}
				zoom={12}
			>
				<TileLayer
					className="custom-opacity-tiles"
					attribution="Google Maps"
					url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
				/>
				{gisDataArr.map((record, index) => (
					<Marker key={index} position={[record.lat, record.lon]} icon={customIconUser}>
						<Popup>
							<div>
								<p><p style={{fontWeight: "bold"}}>Your Location</p></p>
								<p>To change, add new location above</p>
							</div>
						</Popup>
					</Marker>
				))}
				{jobLocations.length > 0 ? jobLocations.map((record, index) => (
					<Marker key={index} position={[record.lat, record.lon]} icon={customIcon}>
						<Popup>
							<div>
								<p><p style={{fontWeight: "bold"}}>{record.title}</p></p>
								<p><p style={{fontWeight: "bold", color: "blue"}}>{record.company}</p></p>
								{/*<p>{record.description}</p>*/}
								{/*<p>Salary: {record.salary}</p>*/}
								<a href={record.jobUrl} target="_blank" rel="noopener noreferrer">Job Link</a>
							</div>
						</Popup>
					</Marker>
				)) : null}
				<RecenterMap gisData={gisDataArr}/>
				<FitBounds bbox={bbox}/>
			</MapContainer>
			<DiscreteSliderValues getAndSetCurrentDistanceValue={getAndSetCurrentDistanceValue}/>
			<label>App. Driving Distance = {1.4 * miles} miles</label>
			<div style={{
				display: "flex", borderRadius: "10px", padding: "10px",
			}}>
				<input id='joburl' type='text' placeholder='paste job link here' style={{
					border: "1px solid grey",
					height: "40px",
					width: "500px",
					borderRadius: "10px",
					padding: "5px",
					color: "grey"
				}}/>
				<Button type='submit' variant='outlined' style={{
					marginLeft: "20px", height: "30px", marginTop: "5px"
				}} onClick={addJobUrl}>Add Job</Button>
				<div id='joburllabel' style={{marginLeft: "20px"}}>< /div>
				
				<div style={{display: "flex", alignItems: "center"}}>
					{/*padding: "10px", */}
					<div style={{display: "flex"}}>
						<input id='userSearchString' placeholder='search' onChange={filterBySearch} style={{
							border: "1px solid grey", height: "40px", width: "300px", borderRadius: "10px", padding: "5px", color: "grey"
						}}/>
						<label style={{marginTop: "10px", marginLeft: "10px"}}>Filtered : {jobUtils.getFormatted(fltrdjoburls.length)}</label>
					</div>
				</div>
			</div>
			
			<div style={{
				maxHeight: "700px", overflow: "scroll", border: "1px solid lightgrey", borderRadius: "10px",
				padding: "15px",
				fontSize: "14px"
			}}>
				<table style={{width: "100%"}}>
					<th style={{
						maxWidth: "30px", overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Row
					</th>
					<th style={{
						maxWidth: "100px", overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Job Url
					</th>
					<th style={{
						maxWidth: "80px", overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Company Name
					</th>
					<th style={{
						maxWidth: "200px", overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Title
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Date Posted
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Offsite Job
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px",
						fontSize: "14px"
					}}>Remote Job
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px", fontSize: "14px"
					}}>Locations
					</th>
					<th style={{
						overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px", fontSize: "14px"
					}}>Lat Longs
					</th>
					{/*<th style={{*/}
					{/*	overflow: "scroll", maxHeight: "20px", border: "1px solid lightgrey", borderRadius: "10px", padding: "5px", fontSize: "14px"*/}
					{/*}}>Job Summary*/}
					{/*</th>*/}
					{/*<th style={{*/}
					{/*	overflow: "scroll", maxHeight: "20px",*/}
					{/*	border: "1px solid lightgrey",*/}
					{/*	borderRadius: "10px", padding: "5px",*/}
					{/*	fontSize: "14px", height: "20px"*/}
					{/*}}>Keywords*/}
					{/*</th>*/}
					{/*<th style={{*/}
					{/*	overflow: "scroll", maxHeight: "20px",*/}
					{/*	border: "1px solid lightgrey",*/}
					{/*	borderRadius: "10px", padding: "5px",*/}
					{/*	fontSize: "14px", height: "20px"*/}
					{/*}}>Page Source*/}
					{/*</th>*/}
					{fltrdjoburls.map((record, index) => {
						return (<tr key={index} style={{}}>
							<td style={{
								minWidth: "50px",
								textAlign: "center",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px"
							}}>{index + 1}</td>
							<td style={{
								minWidth: "50px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px"
							}}>
								<a href={record.jobUrl.trim()} target='_blank'>
									{record.jobUrl}
								</a>
							</td>
							<td style={{
								minWidth: "50px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.extractCompanyName(record.jobUrl)}
							</td>
							<td style={{
								minWidth: "200px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.getTitleText(record)}
							</td>
							<td style={{
								minWidth: "120px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey", borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.getDatePosted(record)}
							</td>
							<td style={{
								minWidth: "120px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.isOffsiteJob(record)}
							</td>
							<td style={{
								minWidth: "120px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.isRemoteJob(record)}
							</td>
							<td style={{
								minWidth: "120px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.getLocationsInfo(record)}
							</td>
							<td style={{
								maxWidth: "200px",
								overflow: "scroll",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "5px",
								textAlign: "center"
							}}>
								{jobUtils.getLatLongs(record)}
							</td>
							{/*<td style={{*/}
							{/*	minWidth: "220px", overflow: "scroll", fontSize: "12px", border: "1px solid lightgrey", borderRadius: "10px",*/}
							{/*}}>*/}
							{/*	<div style={{*/}
							{/*		marginLeft: "10px", textAlign: "left", maxHeight: "200px", display: "block"*/}
							{/*	}}>*/}
							{/*		{getJobSummary(record)}*/}
							{/*	</div>*/}
							{/*</td>*/}
							{/*<td style={{*/}
							{/*	minWidth: "220px", overflow: "scroll", fontSize: "12px", border: "1px solid lightgrey", borderRadius: "10px",*/}
							{/*}}>*/}
							{/*	<div style={{*/}
							{/*		marginLeft: "10px", textAlign: "left", maxHeight: "200px", display: "block"*/}
							{/*	}}>*/}
							{/*		{getKeywords(record)}*/}
							{/*	</div>*/}
							{/*</td>*/}
							{/*<td style={{*/}
							{/*	minWidth: "200px",*/}
							{/*	overflow: "scroll",*/}
							{/*	fontSize: "12px",*/}
							{/*	border: "1px solid lightgrey",*/}
							{/*	// borderRadius: "10px",*/}
							{/*	padding: "5px",*/}
							{/*	textAlign: "center"*/}
							{/*}}>*/}
							{/*	<div style={{maxHeight: "100px", overflowY: "auto", display: "block"}}>*/}
							{/*		<Button variant='outlined' style={{height: "20px"}} onClick={() => copyText(record.page_text)}>Copy Txt</Button>*/}
							{/*		{record.page_text}*/}
							{/*	</div>*/}
							{/*</td>*/}
							{/*<td style={{*/}
							{/*	// width: "200px",*/}
							{/*	overflow: "scroll",*/}
							{/*	fontSize: "12px",*/}
							{/*	border: "1px solid lightgrey", borderRadius: "10px", padding: "10px",*/}
							{/*	textAlign: "center"*/}
							{/*}}>*/}
							{/*	<div style={{*/}
							{/*		maxHeight: "200px", overflowY: "auto", display: "block",*/}
							{/*		maxWidth: "300px", textAlign: "left", minWidth: "150px"*/}
							{/*	}}>*/}
							{/*		<Button variant='outlined' style={{height: "20px", fontSize: "13px"}} onClick={() => copyText(record.pg_source)}>Copy*/}
							{/*			Txt</Button>*/}
							{/*		{getPageSource(record)}*/}
							{/*	</div>*/}
							{/*</td>*/}
						</tr>)
					})}
				</table>
			</div>
			{/*<EditableTable style={{marginTop: "20px"}}/>*/}
			{/*<div style={{marginTop: "20px"}}></div>*/}
			{/*<p style={{fontWeight: "bold"}}>Ready for application</p>*/}
			{/*<EditableTable style={{marginTop: "20px"}}/>*/}
			{/*<div style={{marginTop: "20px"}}></div>*/}
			{/*<p style={{fontWeight: "bold"}}>Discarded</p>*/}
			{/*<EditableTable style={{marginTop: "20px"}}/>*/}
		</div>)
	}
}